module.exports = __webpack_public_path__ + "components/ServicesHeader/logo.png?40ede5ce";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesHeader/logo.png
// module id = 1053
// module chunks = 0